export default function AboutContent() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <div className="rounded-3xl overflow-hidden shadow-lg">
              <img
                src="https://static.readdy.ai/image/12306700e4421a2fbf2cd7195169e5c5/659ad4375971ab9155c2836f11680737.jpeg"
                alt="Cole LaCrue"
                className="w-full h-[500px] object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-3">
            <h2 className="font-sora font-bold text-5xl text-charcoal mb-6">
              I'm Cole LaCrue, founder of LaCrue Digital Agency.
            </h2>
            
            <div className="space-y-6 font-inter text-lg text-gray-700 leading-relaxed">
              <p>
                As a Division I quarterback, I've built my career around discipline, preparation, and performance under pressure — the same standards that shape every project delivered through LaCrue Digital Agency. Attention to detail, accountability, and execution are non-negotiable.
              </p>
              
              <p>
                I started this agency because I saw too many local businesses struggling with outdated websites and zero online visibility. They deserved better.
              </p>
              
              <p>
                My focus is simple: build clean, fast websites that actually bring in customers. No fluff. No unnecessary complexity. Just results.
              </p>
              
              <p>
                When you work with me, you get direct communication, fast turnaround, and a website you'll be proud to share.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}